

















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Customer from '@/models/Customer';
import formatCustomer from '@/utils/formatCustomer';
import Address from '@/models/Address';
import compact from 'lodash/compact';
import moment from 'moment';
import { getCustomersPrescriber } from '@/api/api';
import debounce from 'lodash/debounce';
import MetaDatatable from '@/models/MetaDatatable';
import {
    customerStatusMini,
    formatCustomerStatus,
    customerStatusColors,
} from '@/data/customerStatus';

@Component({
    filters: {
        formatCustomer,
        formatAddress(address: Address) {
            if (!address) {
                return '';
            }
            return `${address.city} (${address.postal_code})`;
        },
        formatDate(date: string) {
            return moment(date).format('L');
        },
        formatCustomerStatus,
    },
})
export default class ProspectsList extends Vue {
    searchStr: string = '';
    customers: Customer[] = [];
    loading: boolean = false;
    loadingContent: boolean = false;
    meta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: -1,
        search: null,
        orderBy: 'createdAt',
        orderWay: 'desc',
        filters: {
            prescribers: undefined,
            status: undefined,
        },
    };
    status: string | null = null;

    async created() {
        this.loading = true;
        await this.fetch();
        this.loading = false;
    }

    async fetch() {
        this.loadingContent = true;
        const { data } = await getCustomersPrescriber(this.meta);
        this.customers = data.data;
        this.loadingContent = false;
    }

    debouncedOnSearchChange = debounce(this.onSearchChange, 300);

    onSearchChange() {
        this.meta.search = this.searchStr;
        this.fetch();
    }

    @Watch('searchStr')
    onSearch() {
        this.debouncedOnSearchChange();
    }

    onStatusChange() {
        this.meta.filters.status = this.status;
        this.fetch();
    }

    getCustomerStatusColor(
        status: 'in_progress' | 'standby' | 'archived' | 'processed'
    ) {
        if (status in customerStatusColors) {
            return customerStatusColors[status];
        }
        return `rgba(var(--vs-primary), 1)`;
    }

    get customerStatus() {
        return Object.entries(customerStatusMini).map(([key, value]) => ({
            text: value,
            value: key,
        }));
    }
}
